import React from 'react'
import { useTranslation } from 'react-i18next'
import FormControl from '@mui/material/FormControl'
import { FormHelperText, MenuItem, SelectProps, Select as MUISelect, InputLabel } from '@mui/material'

type Item = {
  label: string
  value: number | string
}

type Props = SelectProps & {
  errorMessage?: string | null
  label?: string
  items?: Item[]
}

export function Select ({ errorMessage = null, label, items, ...rest }: Props) {
  const invalid = !!errorMessage
  const { t } = useTranslation()

  return (
    <FormControl>
      <InputLabel>{label}</InputLabel>
      <MUISelect label={label} {...rest}>
        {items?.map(({ label, value }, key) =>
          <MenuItem value={value.toString()} key={key}>{t(label)}</MenuItem>
        )}
      </MUISelect>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  )
}
